var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11_2805",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.355469,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11_2805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 22.3555C5.45 22.3555 4.97917 22.1596 4.5875 21.768C4.19583 21.3763 4 20.9055 4 20.3555V10.3555C4 9.80547 4.19583 9.33464 4.5875 8.94297C4.97917 8.5513 5.45 8.35547 6 8.35547H7V6.35547C7 4.97214 7.4875 3.79297 8.4625 2.81797C9.4375 1.84297 10.6167 1.35547 12 1.35547C13.3833 1.35547 14.5625 1.84297 15.5375 2.81797C16.5125 3.79297 17 4.97214 17 6.35547V8.35547H18C18.55 8.35547 19.0208 8.5513 19.4125 8.94297C19.8042 9.33464 20 9.80547 20 10.3555V20.3555C20 20.9055 19.8042 21.3763 19.4125 21.768C19.0208 22.1596 18.55 22.3555 18 22.3555H6ZM6 20.3555H18V10.3555H6V20.3555ZM9 8.35547H15V6.35547C15 5.52214 14.7083 4.8138 14.125 4.23047C13.5417 3.64714 12.8333 3.35547 12 3.35547C11.1667 3.35547 10.4583 3.64714 9.875 4.23047C9.29167 4.8138 9 5.52214 9 6.35547V8.35547Z",
    fill: "#7E8488"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockLocked);
export default __webpack_public_path__ + "static/media/lock_locked.f592d83b7dc495c48eeb0ade3b299e25.svg";
export { ForwardRef as ReactComponent };